import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Devuelve el scroll al principio al cambiar de ruta.
//
// Sin esto, react-router conserva el desplazamiento entre páginas: al saltar
// desde el pie de /noticias a un artículo, el lector aterrizaba a media página
// sin ver el titular.
//
// Tres matices:
//   • Si la URL trae un hash (#cursos), se busca ese elemento en lugar de subir.
//   • En una navegación POP (atrás/adelante) se respeta la posición previa, que
//     es lo que el usuario espera del navegador.
//   • El salto es instantáneo a propósito: un scroll suave de varias pantallas
//     al cambiar de página marea y retrasa la lectura.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;

    if (hash) {
      // El destino puede no existir todavía si la página aún está montando.
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ block: "start" });
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}
